<div
  ng2FileDrop
  [ngClass]="{
    'file-drop-over': hasBaseDropZoneOver,
    'hidden-drop-container': this.currentFile
  }"
  (onFileDrop)="onFileSelected($event)"
  (fileOver)="hasBaseDropZoneOver = $event"
  [uploader]="uploader"
  class="rounded file-drop-zone mt-1 action d-flex flex-column align-items-center justify-content-center"
  (click)="fileInput.click()"
>
  <i class="fa fa-cloud-upload-alt text-primary" style="font-size: 2rem"></i>
  <div class="text-title">Haz clic o arrastra un archivo aquí</div>
  <small class="d-block text-subtle"
    >Formatos permitidos: <strong>{{ allowedTypes }}</strong></small
  >
  <small class="text-subtle"
    >Máximo un archivo de <strong>{{ maxSize }}</strong></small
  >
</div>

<input
  #fileInput
  type="file"
  (change)="onFileSelected($event.target.files)"
  style="display: none"
  [multiple]="false"
  [accept]="mimeTypes.join(',')"
/>

<div
  class="file-uploaded mt-1 d-flex align-items-center border rounded mb-2"
  *ngIf="!!this.currentFile"
>
  <i class="fa-regular fa-file-lines fa-lg mr-2"></i>

  <div class="flex-grow-1">
    <h6 class="mb-0 text-truncate" style="font-weight: 600">{{ fileName }}</h6>
    <small class="text-muted"
      >{{ fileSize }} | {{ fileRows.length }} filas</small
    >
  </div>

  <i
    ngbTooltip="Remover archivo cargado"
    class="fa-solid fa-xmark ml-3 remove-icon"
    style="font-size: 20px"
    role="button"
    (click)="removeFile()"
    title="Eliminar archivo"
  ></i>
</div>
